<template>
	<div class="coupons">
		<van-row>
			<van-col span="24" class="myCoupons-tab-box">
				<div class="myCoupons-tab" :class="{'myCoupons-tab-on':cur==1}" v-on:click="change(1)">未使用</div>
				<div class="myCoupons-tab" :class="{'myCoupons-tab-on':cur==2}" v-on:click="change(2)">已使用</div>
				<div class="myCoupons-tab" :class="{'myCoupons-tab-on':cur==3}" v-on:click="change(3)">已过期</div>
			</van-col>
		</van-row>
		<van-row>
			<van-col span="24" class="coupons-all-container" v-show="cur==1">
				<div class="mycoupons-item" v-for="(item, index) in coupons" :key="index" @click="goTODetail(item)">
					<div class="mycoupons-topinfo">
						<div class="mycoupons-left">
							<div class="mycoupons-name">{{item.coupon_name}}</div>
							<div class="mycoupons-date">{{item.coupon_starttime}}—{{item.coupon_endtime}}</div>
							<div class="mycoupons-limit">满{{item.coupon_use_condition}}元可用</div>
						</div>
						<div class="mycoupons-right">
							<div class="mycoupons-priceinfo">
								<div class="mycoupons-icon">￥</div><div class="mycoupons-num">{{item.coupon_par_value}}</div>
							</div>
						</div>
					</div>
					<div class="mycoupons-limitinfo">优惠券</div>
				</div>
			</van-col>
			<van-col span="24" class="coupons-all-container" v-show="cur==2">
				<div class="mycoupons-item mycoupons-out" v-for="(item, index) in coupons" :key="index" @click="goTODetail(item)">
					<div class="mycoupons-topinfo">
						<div class="mycoupons-left">
							<div class="mycoupons-name mycoupons-out">{{item.coupon_name}}</div>
							<div class="mycoupons-date">{{item.coupon_starttime}}—{{item.coupon_endtime}}</div>
							<div class="mycoupons-limit">满{{item.coupon_use_condition}}元可用</div>
						</div>
						<div class="mycoupons-right">
							<div class="mycoupons-priceinfo mycoupons-out">
								<div class="mycoupons-icon">￥</div><div class="mycoupons-num">{{item.coupon_par_value}}</div>
							</div>
						</div>
					</div>
					<div class="mycoupons-limitinfo mycoupons-out">优惠券</div>
					<van-image class="outoficon" fit="cover" src="../../../static/images/alreadyused.png" />
				</div>
			</van-col>
			<van-col span="24" class="coupons-all-container" v-show="cur==3">
				<div class="mycoupons-item mycoupons-out" v-for="(item, index) in coupons" :key="index" @click="goTODetail(item)">
					<div class="mycoupons-topinfo">
						<div class="mycoupons-left">
							<div class="mycoupons-name mycoupons-out">{{item.coupon_name}}</div>
							<div class="mycoupons-date">{{item.coupon_starttime}}—{{item.coupon_endtime}}</div>
							<div class="mycoupons-limit">满{{item.coupon_use_condition}}元可用</div>
						</div>
						<div class="mycoupons-right">
							<div class="mycoupons-priceinfo mycoupons-out">
								<div class="mycoupons-icon">￥</div><div class="mycoupons-num">{{item.coupon_par_value}}</div>
							</div>
						</div>
					</div>
					<div class="mycoupons-limitinfo mycoupons-out">优惠券</div>
					<van-image class="outoficon" fit="cover" src="../../../static/images/outofdate.png" />
				</div>
			</van-col>
		</van-row>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				cur: 1,
				coupons: []
			}
		},
		created(){
			let that = this;
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
			let formdata = new FormData();
			formdata.append('user_id', localStorage.getItem('userId'));
			formdata.append('token', localStorage.getItem('token'));
			formdata.append('type', 1);
			that.$axios.post('http://sls.zhishen.net.cn/api/Usercoupon/myCoupon', formdata)
			.then(function (res) {
				that.coupons = res.data.coupon_list
			})
			.catch(function (error) {
				console.log(error);
			});
			document.title = "我的优惠券"
		},
		methods:{
			//tab切换
			change: function(index) {
				let that = this
				that.cur = index
				let formdata = new FormData();
				formdata.append('user_id', localStorage.getItem('userId'));
				formdata.append('token', localStorage.getItem('token'));
				formdata.append('type', index);
				that.$axios.post('http://sls.zhishen.net.cn/api/Usercoupon/myCoupon', formdata)
				.then(function (res) {
					that.coupons = res.data.coupon_list
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			//优惠券列表进入优惠券详情
			goTODetail: function(item){
				window.location.href = this.login.pageUrl + '/getCoupons?' + item.coupon_code; 
			}
		}
	}
</script>

<style>
	@import url("../../assets/css/coupons.css");
</style>



// WEBPACK FOOTER //
// src/view/coupons/myCoupons.vue